import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Route, Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import InlineTextDisplay from '../Controls/InlineTextDisplay';

@withRouter
class NewsItem extends React.Component<any, any> {

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        if (window.location.hash) {
            let hash = window.location.hash.replace('#', '');
            if (hash) {
                const domElement = ReactDOM.findDOMNode(this.refs[hash]);
                if (domElement) {
                    domElement.scrollIntoView(true);
                }
            }
        }
    }


    render() {
        const { id, location, children, title, subtitle, date, text, caption, img, link, anchor, ...props } = this.props;

        let anchorName = anchor;
        if (!anchorName) {
            anchorName = id.toString();
        }

        let externalLink = link ? <a className="" target="_blank" href={link}><strong><u>Read more</u></strong></a> : undefined;

        let itemCss = `row`;
        let localLink = `${window.location.origin}/${window.location.pathname}#${anchorName}`;
        return (
            <div className={itemCss} key={"news-" + id}>
                <a ref={anchorName} id={anchorName} className="anchor-detail" />
                <div className="col-12 ">
                    <div className="container news-item">

                        <div className="row">
                            <div className="col-12 col-sm-8 mt-3 mt-sm-0">
                                <span className="text-muted py-1">{date}</span>

                                <div className="news-header py-2" >{title}</div>
                                <div className="news-subheader my-1" >{subtitle}</div>
                            </div>
                            <div className="col-12 col-sm-4">
                                <div className="text-right news-subheader">
                                    <ul className="news-links">
                                        <li>
                                            <a href={`mailto:?subject=${title}&body=${localLink}`} ><i className="fa fa-envelope" aria-hidden="true"></i></a>
                                        </li>
                                        <li>
                                            <a target="_blank" href={`http://twitter.com/intent/tweet?text=${title}%20${encodeURIComponent(localLink)}`}><i className="fa fa-twitter " aria-hidden="true"></i></a>
                                        </li>
                                        <li>
                                            <a target="_blank" href={`http://www.facebook.com/sharer.php?u=${encodeURIComponent(localLink)}&t=${title}`}><i className="fa fa-facebook" aria-hidden="true"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-8 mt-3 mt-sm-0">
                                <InlineTextDisplay source={text} />
                                {externalLink}
                            </div>
                            <div className="col-12 col-sm-4">
                                <img src={img} style={{minHeight: '260px'}}/>
                                <div className="text-muted small mt-1">
                                    {caption}
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr className="my-4" />
                </div>
            </div>
        )
    }
}

@withRouter
class NewsDisplay extends React.Component<any, any> {

    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        //this.scrollNewsIntoView();
    }

    componentDidUpdate(prevProps) {
        /*if (!this.props.isLoading && prevProps.isLoading) {
            this.scrollNewsIntoView();
        }*/
    }

    /*
    scrollNewsIntoView() {
        if (this.props.location) {
            let hash = this.props.location.hash;
            if (hash) {
                console.log('looing', this.refs, hash.replace('#', ''))
                const domElement = ReactDOM.findDOMNode(this.refs[hash.replace('#', '')]);
                if (domElement) {
                    console.log('found', domElement)
                    domElement.scrollIntoView(false);
                }
            }
        }
    }*/

    render() {
        if (!this.props.news || this.props.isLoading) {
            return (<div></div>);
        }

        let items = this.props.news.map((item, index) => {
            return <NewsItem key={"newsItem" + index} {...item}></NewsItem>;
        });

        return (
            <section className="content base3-bg" >
                <div className="container pt-2  mb-4 ">
                    <h1>NEWS</h1>
                </div>
                {items}
            </section>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        news: state.siteData.siteData.news,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const NewsContainer = connect(mapStateToProps, mapDispatchToProps)(
    NewsDisplay
);

export default NewsContainer;


// WEBPACK FOOTER //
// ./src/components/news/NewsContainer.tsx